import React, { useEffect, useState, useCallback } from "react";

import {
  GET_FEEDBACKS_REQUEST,
  LOADMORE_FEEDBACKS_REQUEST,
} from "redux/reducers/service/actionTypes";
import { SET_MESSAGES_REDUCER } from "redux/reducers/messages/actionTypes";
import { push } from "connected-react-router";
import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import { useSelector } from "react-redux";
import { reducerType } from "redux/reducers";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import Loading from "components/Loading";
import FeedbacksContainer from "containers/FeedbacksContainer";
import { Feedback } from "@shelter/core/dist/models";
import { UserRole } from "common";
import { useTranslation } from "react-i18next";
import GridFullHeight from "components/GridFullHeight";
import GridFormContainer from "components/GridFormContainer";
import clsx from "clsx";
import styles from "./styles";
import Container from "@material-ui/core/Container";
import Alert from "components/Alert";
import { archiveFeedback, deleteFeedback } from "api/feedbacks/create";
import HeaderBarSub2 from "components/HeaderBarSub2";

interface FeedbacksProps {
  dispatch: Dispatch;
  feedbacks: Feedback[];
  loading: boolean;
  loadingMore: boolean;
  canLoadmore: boolean;
}

const mapStateToProps = (state: reducerType) => {
  return {
    loading: state.service.loading,
    feedbacks: state.service.feedbacks,
    loadingMore: state.service.loadingMore,
    canLoadmore: state.service.canLoadmore,
  };
};

interface TabOptionProps {
  index: number;
  label: string;
  filter: string;
  type: string;
  isArchive?: boolean;
}

const Feedbacks = React.memo((props: FeedbacksProps) => {
  const { dispatch, loading, loadingMore, canLoadmore } = props;
  const [feedbacks, setFeedbacks] = useState(props.feedbacks);
  const classes = styles();
  const current_user = useSelector(
    (state: reducerType) => state.auth.current_user
  );
  const translate = useTranslation().t;
  const [openAlert, setOpenAlert] = useState(false);
  const [selectedFeedback, setSelectedFeedback] = useState();
  const [typeHandler, setTypeHandler] = useState("");
  const [searchKeyword, setSearchKeyword] = useState("");

  const TABS_OPTIONS: TabOptionProps[] = [
    {
      index: 0,
      label: "APP_FEEDBACK",
      filter: "type",
      type: "APP",
    },
    {
      index: 1,
      label: "SERVICE_FEEDBACK",
      filter: "type",
      type: "SERVICE",
    },
    {
      index: 2,
      label: "VOLUNTEER_FEEDBACKS",
      filter: "type",
      type: "VALIDATION",
    },
    {
      index: 3,
      label: "ARCHIVE",
      filter: "isArchive",
      type: "",
    },
  ];
  const [selectedTab, setSelectedTab] = useState<TabOptionProps>(
    current_user.role === UserRole.Administrator
      ? TABS_OPTIONS[0]
      : current_user.role === UserRole.VolunteerLead
      ? TABS_OPTIONS[0]
      : TABS_OPTIONS[1] // User, Guest
  );

  const handleCloseAlert = () => {
    setOpenAlert(false);
    setSelectedFeedback(null);
  };

  const handleArchive = (id) => {
    setOpenAlert(true);
    setSelectedFeedback(id);
    setTypeHandler("archive");
  };

  const handleDelete = (id) => {
    setOpenAlert(true);
    setSelectedFeedback(id);
    setTypeHandler("delete");
  };

  const handleClickYes = () => {
    selectedFeedback && onHandlerFeedback(selectedFeedback);
    handleCloseAlert();
    setTypeHandler("");
  };

  const getParams = useCallback(() => {
    let params: {
      filter: string;
      type?: string;
      isArchive?: boolean;
      search?: string;
      q?: string;
    } = {
      filter: selectedTab.filter + ",isArchive",
      type: selectedTab.type,
      isArchive: false,
    };
    if (selectedTab.filter === "isArchive") {
      params = {
        filter: "isArchive",
        isArchive: true,
      };
    }
    if (searchKeyword.trim()) {
      params = {
        ...params,
        search: "subject, message",
        q: searchKeyword.trim(),
      };
    }
    return params;
  }, [selectedTab.filter, selectedTab.type, searchKeyword]);

  const fetchFeedbacks = useCallback(() => {
    dispatch({
      type: GET_FEEDBACKS_REQUEST,
      params: getParams(),
    });
  }, [dispatch, getParams]);

  const loadmoreFunction = () => {
    dispatch({
      type: LOADMORE_FEEDBACKS_REQUEST,
      params: getParams(),
    });
  };

  const openUrl = (url) => {
    dispatch(push(url));
  };

  const handleSearchFeedbacks = useCallback((keyword: string) => {
    setSearchKeyword((keyword || "").trim());
  }, []);

  const onHandlerFeedback = async (id: string) => {
    try {
      let res;
      if (typeHandler === "archive") {
        res = (await archiveFeedback(id)) as any[];
      } else if (typeHandler === "delete") {
        res = (await deleteFeedback(id)) as any[];
      }
      if (res) {
        dispatch({
          type: SET_MESSAGES_REDUCER,
          message: {
            type: "success",
            key: "",
            message: `This feedback was ${typeHandler}d successful!`,
          },
        });
        fetchFeedbacks();
      }
    } catch (error) {}
  };

  const getTabsByRole = () => {
    if (current_user.isAdmin) {
      return TABS_OPTIONS;
    } else if ((current_user.role === UserRole.VolunteerLead)) {
      return [TABS_OPTIONS[0], TABS_OPTIONS[2], TABS_OPTIONS[3]];
    } else {
      return [TABS_OPTIONS[1], TABS_OPTIONS[3]];
    }
  };

  useEffect(() => {
    fetchFeedbacks();
  }, [fetchFeedbacks]);

  useEffect(() => {
    setFeedbacks(props.feedbacks);
  }, [props.feedbacks]);

  return (
    <GridFullHeight container>
      <GridFormContainer item xs={12} sm={12} md={12}>
        <GridFullHeight container>
           <HeaderBarSub2
            openUrl={openUrl}
            isSearch={true}
            name={translate("MY_FEEDBACKS")}
            handleSearch={handleSearchFeedbacks}
            searchPlaceholder={translate("SEARCH_FEEDBACK")}
          />
          <Container className={classes.root}>
            <ButtonGroup
              className={classes.groupBtns}
              variant="contained"
              color="primary"
              aria-label="contained primary button group"
            >
              {getTabsByRole().map((tab, idx) => (
                <Button
                  key={idx}
                  onClick={() => setSelectedTab(tab)}
                  className={clsx(
                    {
                      [classes.btnActive]: tab.index === selectedTab.index,
                    },
                    classes.btnFilter
                  )}
                >
                  {translate(tab.label)}
                </Button>
              ))}
            </ButtonGroup>
          </Container>
          {loading ? (
            <Loading />
          ) : (
            <>
              <FeedbacksContainer
                selectedIndex={selectedTab.index}
                openUrl={openUrl}
                feedbacks={feedbacks}
                loadmoreFunction={loadmoreFunction}
                loadingMore={loadingMore}
                canLoadmore={canLoadmore}
                handleArchive={handleArchive}
                handleDelete={handleDelete}
              />
              <Alert
                title={`Do you want to ${typeHandler} this Feedback?`}
                open={openAlert}
                handleClose={handleCloseAlert}
                handleClickYes={handleClickYes}
              />
            </>
          )}
        </GridFullHeight>
      </GridFormContainer>
    </GridFullHeight>
  );
});

export default connect(mapStateToProps)(Feedbacks);
